/**
 * Делает заглавной первую букву строки:
 *  Input: 'янино-1 пгт';
 *  Output: 'Янино-1 пгт'.
 *  */

export const upperFirstLetter = (value: string | null | undefined): string => {
  return value ? value[0].toUpperCase() + value.slice(1) : '';
};
